var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "50%", hideClose: "" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", {}, [
                _c("h4", { staticClass: "cursive" }, [
                  _vm._v("Preventivo creato con successo!")
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "text-uppercase pr-2" }, [
                    _vm._v("preventivo n°:")
                  ]),
                  _c("span", { staticClass: "text-primary" }, [
                    _vm._v(_vm._s(_vm.numeroPratica))
                  ])
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "container mt-3" }, [
          _c("h5", { staticClass: "cursive mb-3" }, [
            _vm._v(
              "\n        Il tuo preventivo numero " +
                _vm._s(_vm.numeroPratica) +
                " è stato creato con\n        successo!\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("b", [
              _vm._v(
                "Presentati nella tua Agenzia di fiducia, indicando il tuo numero di\n          preventivo"
              )
            ]),
            _vm._v(
              ", per ricevere maggiori informazioni, richiedere eventuali modifiche\n        e definire tutti i dettagli della tua partenza\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Al momento nessun volo o servizio a terra è stato prenotato e/o\n        opzionato.\n      "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Prezzi e disponibilità sono soggetti a riconferma al momento della\n        prenotazione in Agenzia.\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column flex-md-row mb-5 p-5" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary px-5 m-1",
                  attrs: { id: "visualizzaRiepilogo" },
                  on: { click: _vm.onVisualizza }
                },
                [
                  _vm._v(
                    "\n          Visualizza il riepilogo del tuo viaggio\n        "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.isAuthenticated()
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info m-1 px-5 position-relative",
                      attrs: { id: "trovaAgenzie" },
                      on: { click: _vm.onFindAgy }
                    },
                    [
                      _c("span", {
                        staticClass:
                          "mdi mdi-map-marker-outline mdi-18px text-white",
                        staticStyle: {
                          position: "absolute",
                          left: "10px",
                          top: "50%",
                          transform: "translateY(-50%)"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ms-4" }, [
                        _vm._v("Trova l'agenzia più vicina a te")
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.toSend
            ? _c("div", { staticClass: "bg-light px-4 py-5 mb-4" }, [
                _c("p", [
                  _vm._v(
                    "\n          Per ricevere il preventivo via email, inserisci il tuo indirizzo di\n          posta nella casella sottostante.\n        "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-2" }, [
                  _vm._v("Nessun dato personale verrà salvato.")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-md-flex justify-content-md-between" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control mr-3 mb-1",
                      attrs: {
                        type: "email",
                        placeholder: "Inserisci la tua email"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary text-uppercase px-5",
                        attrs: {
                          id: "inviaRiepilogo",
                          disabled: !_vm.isValidEmail
                        },
                        on: { click: _vm.onInviaEmail }
                      },
                      [_vm._v("\n            invia\n          ")]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c(
              "a",
              {
                staticClass: "default-bold text-uppercase text-secondary",
                attrs: { href: "/" },
                on: {
                  click: function($event) {
                    return _vm.trackModaleCompletaPreventivoChiudi()
                  }
                }
              },
              [_vm._v("torna alla home")]
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-873370c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-873370c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/modals/ModalCompletaPratica.vue
// module id = null
// module chunks = 